'use strict';

frontendApp.factory('CollectionMimeTypeService', ['$resource', '$rootScope', 'ConfigService', 'ResourceWrapperService', function ($resource, $rootScope, ConfigService, ResourceWrapperService) {

  var _service = {};

  var RawCollectionMimeTypeResource = $resource(ConfigService.getServerBaseUrlForResource() + '/project/:projectId/collection/:collectionId/mimeTypes',
    {'id': '@id', 'projectId': '@projectId', 'collectionId': '@collectionId'},
    {'query': {method: 'GET', params: {page: 1, limit: 10}, isArray: true}});

  var CollectionMimeType = ResourceWrapperService.WrapActions(RawCollectionMimeTypeResource);

  _service.findAll = function (projectId, collectionId, page, limit, callback) {
    return CollectionMimeType.query({
      projectId: projectId,
      collectionId: collectionId,
      page: page,
      limit: limit
    }, function (mimeTypes) {
      if (callback) callback(mimeTypes);
    });
  };

  return _service;

}]);

